// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"ddb587ac","228":"3afa280c","358":"e43065b7","453":"841296c2","696":"26c88602","790":"04fb2e4b","871":"876ed80a","929":"c1287e99","945":"1afd508a"}[chunkId] + ".chunk.js";
};